const DEFAULT_STEPS = [
  { num: 1, title: 'Share Your Link', description: 'Share your unique referral link or code with friends and colleagues.', order: 0, isActive: true },
  { num: 2, title: 'Friend Signs Up', description: 'Your friend creates an account using your referral link.', order: 1, isActive: true },
  { num: 3, title: 'They Make a Purchase', description: 'When they purchase any service, you earn your reward!', order: 2, isActive: true },
  { num: 4, title: 'Earn 1000 Points', description: 'Get 1000 reward points to use towards your next purchase.', order: 3, isActive: true },
];

export const getReferAndEarnPageMeta = (content) => ({
  pageTitle: content?.pageTitle || 'Refer & Earn',
  pageSubtitle: content?.pageSubtitle || 'Invite friends and earn 1000 reward points for each successful referral!',
  pageIcon: content?.pageIcon || 'LuGift',
  loadingMessage: content?.loadingMessage || 'Loading referral data...',
  statsLabels: {
    totalReferrals: content?.statsLabels?.totalReferrals || 'Total Referrals',
    pending: content?.statsLabels?.pending || 'Pending',
    successful: content?.statsLabels?.successful || 'Successful',
    rewardPoints: content?.statsLabels?.rewardPoints || 'Reward Points',
  },
  referralLinkSection: {
    title: content?.referralLinkSection?.title || 'Your Referral Link',
    description:
      content?.referralLinkSection?.description ||
      'Share this link with friends to earn rewards when they sign up and make a purchase.',
    yourCodePrefix: content?.referralLinkSection?.yourCodePrefix || 'Your Code:',
    copyCodeLabel: content?.referralLinkSection?.copyCodeLabel || 'Copy',
    sendInviteButton: content?.referralLinkSection?.sendInviteButton || 'Send Invitation Email',
  },
  howItWorks: {
    title: content?.howItWorks?.title || 'How It Works',
    steps: (content?.howItWorks?.steps?.length ? content.howItWorks.steps : DEFAULT_STEPS)
      .filter((step) => step.isActive !== false)
      .sort((a, b) => (a.order ?? 0) - (b.order ?? 0)),
  },
  referralsTable: {
    title: content?.referralsTable?.title || 'My Referrals',
    columns: {
      email: content?.referralsTable?.columns?.email || 'Email',
      name: content?.referralsTable?.columns?.name || 'Name',
      status: content?.referralsTable?.columns?.status || 'Status',
      invitedOn: content?.referralsTable?.columns?.invitedOn || 'Invited On',
      registered: content?.referralsTable?.columns?.registered || 'Registered',
      reward: content?.referralsTable?.columns?.reward || 'Reward',
    },
  },
  statusLabels: {
    pending: content?.statusLabels?.pending || 'Invitation Sent',
    registered: content?.statusLabels?.registered || 'Signed Up',
    purchased: content?.statusLabels?.purchased || 'Made Purchase',
    rewarded: content?.statusLabels?.rewarded || 'Reward Earned',
  },
  emptyState: {
    description: content?.emptyState?.description || 'No referrals yet. Start inviting friends to earn rewards!',
  },
  inviteModal: {
    title: content?.inviteModal?.title || 'Send Invitation',
    subtitle: content?.inviteModal?.subtitle || "Enter your friend's details",
    emailLabel: content?.inviteModal?.emailLabel || 'Email Address *',
    emailPlaceholder: content?.inviteModal?.emailPlaceholder || 'friend@example.com',
    nameLabel: content?.inviteModal?.nameLabel || "Friend's Name (Optional)",
    namePlaceholder: content?.inviteModal?.namePlaceholder || 'John Doe',
    cancelLabel: content?.inviteModal?.cancelLabel || 'Cancel',
    submitLabel: content?.inviteModal?.submitLabel || 'Send Invitation',
    submittingLabel: content?.inviteModal?.submittingLabel || 'Sending...',
  },
  toasts: {
    loadError: content?.toasts?.loadError || 'Failed to load referral data',
    linkCopied: content?.toasts?.linkCopied || 'Referral link copied to clipboard!',
    codeCopied: content?.toasts?.codeCopied || 'Referral code copied to clipboard!',
    emailRequired: content?.toasts?.emailRequired || 'Please enter an email address',
    emailInvalid: content?.toasts?.emailInvalid || 'Please enter a valid email address',
    inviteSuccess: content?.toasts?.inviteSuccess || 'Invitation sent successfully!',
    inviteError: content?.toasts?.inviteError || 'Failed to send invitation',
  },
  rewardModal: {
    title: content?.rewardModal?.title || 'Refer & Earn Rewards!',
    subtitleHighlight: content?.rewardModal?.subtitleHighlight || '1000 points',
    subtitlePrefix: content?.rewardModal?.subtitlePrefix || 'Help your family and friends earn',
    cardTitle: content?.rewardModal?.cardTitle || 'Refer family & friends',
    cardBadge: content?.rewardModal?.cardBadge || 'HOT',
    cardBody:
      content?.rewardModal?.cardBody ||
      'Invite your friends to BooksComply and earn 1,000 points for every successful referral when they buy any service.',
    linkLabel: content?.rewardModal?.linkLabel || 'Referral Link',
    shareHint: content?.rewardModal?.shareHint || 'Share this link',
    copyLabel: content?.rewardModal?.copyLabel || 'Copy',
    copiedLabel: content?.rewardModal?.copiedLabel || 'Copied',
    shareLabel: content?.rewardModal?.shareLabel || 'Share',
    ctaButton: content?.rewardModal?.ctaButton || 'Start Earning Now',
    skipLabel: content?.rewardModal?.skipLabel || 'Skip referral for now',
    footerNote: content?.rewardModal?.footerNote || '* Reward credited after successful purchase',
    linkLoading: content?.rewardModal?.linkLoading || 'Generating...',
    linkError: content?.rewardModal?.linkError || 'Error loading link',
    shareSuccess: content?.rewardModal?.shareSuccess || 'Shared successfully!',
    shareError: content?.rewardModal?.shareError || 'Failed to share.',
  },
});

export const getReferralStatusLabel = (meta, status) =>
  meta.statusLabels[status] || status;
